import { render, staticRenderFns } from "./cSpineTab.vue?vue&type=template&id=468a57a2&scoped=true&lang=pug"
import script from "./cSpineTab.vue?vue&type=script&lang=js"
export * from "./cSpineTab.vue?vue&type=script&lang=js"
import style0 from "./cSpineTab.vue?vue&type=style&index=0&id=468a57a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468a57a2",
  null
  
)

export default component.exports